import { HTTPClient } from "./Client";

const GrupoDeUsuarioApi = {

    async ListarGrupoDeUsuariosComPaginacaoAsync(pagina, nome, descricao) {
        const payload = {
            Pagina: pagina,
            Nome: nome,
            Descricao: descricao
        };

        const response = await HTTPClient.post(
            `/GrupoDeUsuario/ListarGruposDeUsuariosPaginacao`,
            payload
        );

        return response.data;
    },

    async ObterGrupoDeUsuarioPorIdAsync(grupoDeUsuarioId) {
        try {
            const response = await HTTPClient.get(
                `/GrupoDeUsuario/Obter/${grupoDeUsuarioId}?ativo=true`
            );
            return response.data;
        } catch (error) {
            console.error("Erro ao obter grupo de usuário:", error);
            throw error;
        }
    },

    async CriarGrupoDeUsuarioAsync(nome, descricao) {
        try {
            const payload = { Nome: nome, Descricao: descricao };
            const response = await HTTPClient.post(`/GrupoDeUsuario/Criar`, payload);
            return response.data;
        } catch (error) {
            console.error("Erro ao criar grupo de usuário:", error);
            throw error;
        }
    },

    async AtualizarGrupoDeUsuarioAsync(id, nome, descricao) {
        try {
            const payload = { Id: id, Nome: nome, Descricao: descricao };
            const response = await HTTPClient.put(`/GrupoDeUsuario/Atualizar`, payload);
            return response.data;
        } catch (error) {
            console.error("Erro ao atualizar grupo de usuário:", error);
            throw error;
        }
    },

    async DeletarGrupoDeUsuarioAsync(id) {
        try {
            const response = await HTTPClient.delete(
                `/GrupoDeUsuario/Deletar/${id}`
            );
            return response.data;
        } catch (error) {
            console.error("Erro ao deletar grupo de usuário:", error);
            throw error;
        }
    },

    async RestaurarGrupoDeUsuarioAsync(id) {
        try {
            const response = await HTTPClient.put(
                `/GrupoDeUsuario/Restaurar/${id}`
            );
            return response.data;
        } catch (error) {
            console.error("Erro ao restaurar grupo de usuário:", error);
            throw error;
        }
    },

    async ListarGrupoDeUsuarioAsync(ativos) {
        try {
            const response = await HTTPClient.get(
                `/GrupoDeUsuario/Listar?ativos=${ativos}`
            );
            return response.data;
        } catch (error) {
            console.error("Erro ao listar grupos de usuário:", error);
            throw error;
        }
    },

    async ListarCoordenadoresComPaginacaoAsync(pagina, nome, email) {
        const payload = { Pagina: pagina, Nome: nome, Email: email };
        const response = await HTTPClient.post(
            `/Coordenadores/ListarCoordenadores`,
            payload
        );
        return response.data;
    }
};

export default GrupoDeUsuarioApi;
